import React from 'react';
import { useSearchState } from '@hotelplan/fdr.lib.search.with-state';
import { SearchFilterInputSkeleton } from 'components/domain/filters/search-filter-input/SearchFilterInput.skeleton';
import { ESearchType } from 'fdr/components/candidate/fdr-search-control/destination/fdr-destination-field.types';
import { FdrSearchFiltersList } from 'fdr/components/candidate/fdr-search-filters-controls/fdr-search-filters-list';
import { IWishlistState } from 'fdr/components/local/fdr-wishlist/fdr-wishlist.types';

const FdrWishlistFilterField: React.FC = () => {
  const stateContext = useSearchState<IWishlistState>();

  if (stateContext.loading) return <SearchFilterInputSkeleton />;

  return <FdrSearchFiltersList searchType={ESearchType.WISHLIST} />;
};

export default FdrWishlistFilterField;
